module.exports = __webpack_public_path__ + "img/img-5.6ca5e6f1.png";